import React, { FC, PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { LayoutMenuItem, LanguageSelector, LayoutContent } from '@eta/components';
import { Header,Layout } from '.';
import './PublicLayout.scss';
import { menuItems } from '../../App';
import { authService } from '../../Security/Security';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const url = (window as any).REACT_APP_clientRoot;
export interface LayoutProps {
    menuItems?: LayoutMenuItem[];
}

export const PublicLayout: FC<PropsWithChildren<LayoutProps>> = (
    props: PropsWithChildren<LayoutProps>
) => {
    const { children } = props;
    const { t } = useTranslation(['common', 'Menu']);
    const [isLoading] = useState(false);

    return (
        authService.currentUser ? (
            <Layout menuItems={menuItems}>
                <LayoutContent loading={isLoading}>
                    {children}
                </LayoutContent>
            </Layout>
        ) : (
                <div className="layout">
                    <div className="layout-container">
                        {isLoading ? (
                            <div className="layout-container-loading">
                                <Spinner
                                    size={SpinnerSize.large}
                                    label={t('loading')}
                                />
                            </div>
                        ) : (
                                <div className='layout-container-rightPart' >
                                    <Header mainTitle={t('Profile')}>
                                        <a className='btnLogin' href={url}>
                                            {t('login')}
                                        </a>
                                        <a className='btnSignUP' href="/signUp">
                                            {t('SignUp')}
                                        </a>
                                        <LanguageSelector />
                                    </Header>
                                    <LayoutContent>
                                        {children}
                                    </LayoutContent>
                                </div>
                            )}
                    </div>
                </div>
            )
    );
};
